import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

export class Navbar extends Component {
  state = {
    menuActive: false
  };

  toggleMenu = () => {
    this.setState(prevState => ({ menuActive: !prevState.menuActive }));
  };

  render() {
    return (
      <nav
        className="navbar is-primary p-lr-10p p-b-5px"
        aria-label="main navigation"
      >
        <div className="navbar-brand has-text-weight-semibold">
          <NavLink className="navbar-item" to="/">
            <img
              className="image"
              src="https://res.cloudinary.com/dydyt6wbt/image/upload/v1538806893/blogo.svg"
              alt="www.bhidiroglu.com"
              width="48px"
              height="64px"
              style={{ objectFit: "cover" }}
            />
          </NavLink>
          <a
            role="button"
            className="navbar-burger"
            aria-label="menu"
            aria-expanded="false"
            onClick={this.toggleMenu}
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>
        <div
          className={`navbar-menu is-transparent ${
            this.state.menuActive ? "is-active" : ""
          }`}
        >
          <div className="navbar-end m-a">
            <ScrollLink
              smooth={true}
              duration={500}
              to="hakkimda"
              className="navbar-item has-text-weight-semibold"
            >
              Hakkımızda
            </ScrollLink>
            <ScrollLink
              smooth={true}
              duration={500}
              to="hizmetler"
              className="navbar-item has-text-weight-semibold"
            >
              Hizmetlerimiz
            </ScrollLink>
            <ScrollLink
              smooth={true}
              duration={500}
              to="iletisim"
              className="navbar-item has-text-weight-semibold"
            >
              İletişim
            </ScrollLink>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/navbar/Navbar.js